import React, { useEffect, useState } from "react";
import { FaChevronDown } from "react-icons/fa";
import Notifications from "react-notifications-menu";
import { useDispatch, useSelector } from "react-redux";
import { DropDownLocationIcon } from "../../configs/svg.js";
import { useGetClientsQuery } from "../../Redux/services/adminApi.js";
import { useGetNotificationsQuery } from "../../Redux/services/userAuthApi.js";
import { setSelectedClient } from "../../Redux/Slice/selectRowSlice.js";
import ImageWithPlaceholder from "../CustomComponent/ImagewithPlaceholder.js";
import { ExtraBoldText } from "./ThemeText.js";

const ThemeNavBar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState({value: '', label: "Select Client"});
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(1000);
  const [options, setOptions] = useState([]);
  const [notificationList, setNotificationList] = useState([]);
  const toggleDropdown = () => setIsOpen(!isOpen);
  const user = useSelector((state) => state.authInfo.user);
  const dispatch = useDispatch();

  const {
    data: notification,
    refetch,
    error,
  } = useGetNotificationsQuery({
    refetchOnMountOrArgChange: true,
  });
  // const notification = {
  //   data: [
  //     {
  //       id: 1,
  //       user_id: 2,
  //       type: "test",
  //       title: "Test Title",
  //       message: "Test Message",
  //       image_url: null,
  //       payload: {
  //         title: "Test Title",
  //         message: "Test Message",
  //       },
  //       is_read: false,
  //       created_at: "2025-01-27T10:39:28.000Z",
  //     },
  //   ],
  // };

  useEffect(() => {
    if (notification) {
      const response = notification?.data?.map((x) => {
        return {
          message: (
            <div className="data">
              <div className="data-info">
                <div className="tittle">{x?.title}</div>
                <div className="mesg">{x?.message}</div>
              </div>
            </div>
          ),
        };
      });
      if (response?.length > 0) {
        setNotificationList(response);
      }
    }
  }, [notification]);

  const handleSelect = (option) => {
    setSelectedOption(option);
    dispatch(setSelectedClient(option));
    setIsOpen(false);
  };
  const { data, isSuccess, isFetching } = useGetClientsQuery(
    {
      search: "",
      limit: pageSize,
      page: page,
    },
    {
      refetchOnMountOrArgChange: true,
      skip: user?.user_type !== "ADMIN",
    }
  );
  useEffect(() => {
    if (data) {
      const response = data?.data?.map((x) => {
        return { label: x.name, value: x.id };
      });
      setOptions([{ label: "All Clients", value: "" } , ...response]);
    }
  }, [data]);

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isOpen])

  
  const handleOutsideClick = (event) => {
    const Div = document.getElementById('view-dialogue_client');

    if (!Div?.contains(event.target)) {
      setIsOpen(null);
    }
  }
  const path = window.location.pathname;

  return (
    <div className="theme-navbar">
      <div className="navbar-container d-flex align-items-center justify-content-between h-100">
        {user?.user_type === "ADMIN" && path !== "/dashboard" ? (
          <div
            className="dropdown-container d-none d-lg-flex align-items-center"
            onClick={toggleDropdown}
          >
            <div className="icon">
              <DropDownLocationIcon />
            </div>
            <span>{selectedOption?.label}</span>
            <FaChevronDown className="chevron" />
            {isOpen && (
              <ul id="view-dialogue_client">
                {options.map((option) => (
                  <li key={option?.value} onClick={() => handleSelect(option)}>
                    {option?.label || 'Select Client'}
                  </li>
                ))}
              </ul>
            )}
          </div>
        ) : (
          <div className="d-none d-lg-block"></div>
        )}
        <div className="profile-container d-flex gap-2 align-items-center">
          <Notifications
            style={{ color: "red" }}
            data={notificationList}
            // fetchData
            // prop to fetch data on pagination
            icon={"/images/notificationIcon.png"} // Use the FaRegBell icon component here
            header={{
              title: <h4 className="notification__heading">Notifications</h4>,
              option: {
                // text: <p className="mark__read" onClick={() => setMenuOpen(false)}><CrossNoti /></p>,
              },
            }}
            markAsRead={(data) => {}}
          />
          <div className="profile-image">
            <ImageWithPlaceholder
              src={user?.image_url || "/images/user-placeholder.jpeg"}
              placeholder={"/images/user-placeholder.jpeg"}
              alt="post"
              className="rounded-circle"
              height={40}
              width={40}
            />
          </div>
          <ExtraBoldText text={user?.name} className={"fs-6"} />
        </div>
      </div>
    </div>
  );
};

export default ThemeNavBar;
